/**
 * Display helpers for Immo 360 associated-campaigns consultation (read-only).
 * Membership ≠ mailed / delivered.
 */

import { adminProspectCampaignBuildStatusLabel } from './adminProspectCampaignDisplay.js';
import {
  adminProspectCampaignDetailPath,
  formatAdminDate,
} from './adminProspectDisplay.js';

export function mergeAssociatedCampaignEntries(existing, incoming) {
  const current = Array.isArray(existing) ? existing : [];
  const next = Array.isArray(incoming) ? incoming : [];
  if (!next.length) return current;
  const seen = new Set(current.map((row) => row?.campaignId).filter(Boolean));
  const merged = [...current];
  for (const row of next) {
    if (!row?.campaignId || seen.has(row.campaignId)) continue;
    seen.add(row.campaignId);
    merged.push(row);
  }
  return merged;
}

export function associatedCampaignOpenPath(campaignId) {
  return adminProspectCampaignDetailPath(campaignId);
}

export function formatAssociatedCampaignCreatedAt(value, language) {
  return formatAdminDate(value, language);
}

export function formatAssociatedCampaignIncludedAt(value, language) {
  return formatAdminDate(value, language);
}

export function associatedCampaignBuildStatusLabel(buildStatus, t) {
  return adminProspectCampaignBuildStatusLabel(buildStatus, t);
}

export function associatedCampaignStatusLabel(status, t) {
  if (typeof status !== 'string' || !status.trim()) {
    return t('admin.prospection.associatedCampaigns.status.unknown');
  }
  const key = `admin.prospection.associatedCampaigns.status.${status.trim()}`;
  const label = t(key);
  if (label !== key) return label;
  // Fall back to raw established status string (e.g. draft) without inventing mail states.
  return status.trim();
}

export function associatedCampaignDisplayName(entry, t) {
  if (entry?.name && String(entry.name).trim()) return String(entry.name).trim();
  return t('admin.prospection.associatedCampaigns.name.untitled');
}
